import { useEffect, useState } from 'react';

import dayjs from 'dayjs';

/**
 * Counts down to an ISO target timestamp, re-rendering every second.
 * Returns the remaining whole seconds (clamped at 0), or null when there's no target.
 * Recomputes from the timestamp each tick, so it never drifts.
 */
export function useCountdown(targetIso: string | null | undefined): number | null {
  const remaining = () => (targetIso ? Math.max(0, dayjs(targetIso).diff(dayjs(), 'second')) : null);
  const [seconds, setSeconds] = useState<number | null>(remaining);

  useEffect(() => {
    setSeconds(remaining());
    if (!targetIso) return;
    const id = setInterval(() => setSeconds(remaining()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetIso]);

  return seconds;
}
